// Utilitário para gerenciar permissões de dashboard de forma centralizada - Nova estrutura
export const DASHBOARD_PERMISSIONS = {
  // Permissões principais (requeridas para dashboard principal)
  MAIN_DASHBOARD: [
    'dashboard.view',
  ],
  
  // Mapeamento de rotas para permissões
  ROUTE_PERMISSIONS: [
    { path: '/comercial', permission: 'comercial.view' },
    { path: '/comercial', permission: 'comercial.ranking.view' },
    { path: '/comercial', permission: 'comercial.minhas_vendas.view' },
    { path: '/contratos', permission: 'contratos.view' },
    { path: '/operacional', permission: 'operacional.view' },
    { path: '/operacional', permission: 'operacional.agendamentos.view' },
    // Na posição que o estoque já ocupava: quem caía em /operacional por causa dele passa a cair
    // em /estoque, e nenhum outro usuário muda de destino inicial.
    { path: '/estoque', permission: 'estoque.view' },
    { path: '/operacional', permission: 'operacional.edit' },
    { path: '/infraestrutura', permission: 'infra.view' },
    { path: '/cobranca', permission: 'cobranca.view' },
    { path: '/administrativo', permission: 'administrativo.view' },
    { path: '/financeiro', permission: 'financeiro.view' },
    { path: '/automacoes', permission: 'automacoes.view' },
    { path: '/gestao-solicitacoes', permission: 'solicitacoes.view' },
    { path: '/configuracoes', permission: 'config.usuarios.view' },
    // Adicione novas rotas aqui quando necessário
  ]
};

// Função para obter todas as permissões de view disponíveis
export const getAllViewPermissions = () => {
  return DASHBOARD_PERMISSIONS.ROUTE_PERMISSIONS.map(route => route.permission);
};

// Função para obter permissões do dashboard principal
export const getMainDashboardPermissions = () => {
  return DASHBOARD_PERMISSIONS.MAIN_DASHBOARD;
};

// Função para obter rotas ordenadas por prioridade
export const getOrderedRoutes = () => {
  return DASHBOARD_PERMISSIONS.ROUTE_PERMISSIONS;
};

// Função para adicionar nova rota dinamicamente
export const addNewRoute = (path, permission) => {
  DASHBOARD_PERMISSIONS.ROUTE_PERMISSIONS.push({ path, permission });
};

// Função para adicionar nova permissão ao dashboard principal
export const addMainDashboardPermission = (permission) => {
  if (!DASHBOARD_PERMISSIONS.MAIN_DASHBOARD.includes(permission)) {
    DASHBOARD_PERMISSIONS.MAIN_DASHBOARD.push(permission);
  }
};
